module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Highvoltage-6d963220129432e975e3b94b0183dfcd.svg";